<template>
  <div  class="cx-category"
        v-if="isEnabled">
    <h5>{{ category.name }}</h5>

    <!-- Api and Exploration -->
    <div v-if="!isNonExploration(category.apis[0])">
      <h6>&nbsp;</h6>

      <CxCategoryApiHeader  class="local-row"
                            v-if="explorationData"
                            :afsData="afsData"
                            :apis="category.apis" 
                            :explorationData="explorationData"
                            :nonAfsData="nonAfsData" />

      <div  v-for="(api, index) in category.apis" 
            :key="index"
            :class="{'highlighting': showBadges && getApiData(api) !== undefined  && isApiActive(api) && getDealerThreshold(api) !== undefined }">
        <b-badge  v-if="showBadges && getApiData(api) !== undefined && isApiActive(api) && getDealerThreshold(api) !== undefined"
                  class="weight-badge weight-badge-exploration" 
                  pill 
                  variant="danger">
          {{ getDealerThreshold(api) }}x
        </b-badge>
        <CxCategoryApi  v-if="isApiActive(api)"
                        class="local-row"
                        :afsData="afsData"
                        :api="api"
                        :apiData="getApiData(api)"
                        :nonAfsData="nonAfsData"
                        :threshold="threshold"
                        :dealerData="dealerData"
                        :clientInfo="clientInfo" />
      </div>
    </div>

    <!-- Non Exploration -->
    <div  v-else
          v-for="(api, index) in category.apis"
          :key="index">

      <h6>{{ api.SurveyTitle }}</h6>

        <CxCategoryApiHeader  class="local-row-exploration"
                              v-if="explorationData"
                              :afsData="afsData"
                              :apis="category.apis" 
                              :explorationData="explorationData"
                              :nonAfsData="nonAfsData" />
    
      <div :class="{'highlighting': showBadges}" v-if="isApiActive(api)">
        <b-badge  v-if="showBadges && getApiData(api) !== undefined && isApiActive(api) && getDealerThreshold(api) !== undefined"
                  class="weight-badge weight-badge-nonexploration" 
                  pill 
                  variant="danger">
                  {{ getDealerThreshold(api) }}x
        </b-badge>
        <CxCategoryApi  class="local-row"
                        v-for="(scenario, index) in api.ScenarioResults"
                        :key="index"
                        :afsData="afsData"
                        :api="api"
                        :apiData="getScenarioData(api, scenario)"
                        :nonAfsData="nonAfsData"
                        :threshold="threshold" 
                        :dealerData="dealerData"
                        :clientInfo="clientInfo"/>
      </div>

    </div>
  </div>
</template>

<script>
import CxCategoryApi from './CxCategoryApi.vue';
import CxCategoryApiHeader from './CxCategoryApiHeader.vue';
import CxDashboardContentMixin from "@/mixins/jlr/CxDashboardContentMixin.js";
import EventBus from '@/services/EventBus'

export default {
  mixins: [ CxDashboardContentMixin ],

  components: { CxCategoryApi, CxCategoryApiHeader },

  props: {
    afsData:            { type: Object, default: () => undefined },
    category:           { type: Object, required: true },
    dashboardData:      { type: Object, required: true },
    explorationData:    { type: Array, required: true },
    nonAfsData:         { type: Object, default: () => undefined },
    threshold:          { type: Array, required: true },
    dealerData:         { type: Object, default: () => undefined},
    clientInfo:         { type: Object, default: () => undefined},
  },

  data() {
    return {
      showBadges: false
    }
  },

  created() {
    EventBus.$on('badges', this.handleBadges);
  },

  beforeDestroy() {
    EventBus.$off('badges', this.handleBadges);
  },

  methods: {
    isApiActive(api) {
      if (this.isApi(api)) {
        let apiData = this.getApiData(api);
        return apiData?.isActive;
      } else if (this.isExploration(api)) {
        // Exploration is always active when something is visible
      } else if (this.isNonExploration(api)) {
        // Non-Exploration is always active when something is visible
      }
      return true
    },

    getValue(threshold) {
      return threshold?.Value != null 
        ? threshold?.Value 
        : undefined;
    },

    getWeight(threshold) {
      if (this.getValue(threshold) != null)
        return threshold?.Weight || 0;
      else
        return threshold?.Weight_NoData || 0;
    },

    getDealerThreshold(api, scenario) {
      if (this.isApi(api)) {
        // API dann in Exploration suchen
        let item = Object.values(this.dashboardData.Exploration).find(x => x.ApiID === api.apiId);
        if (item && item.Threshold) {
          return this.getWeight(item.Threshold);
        }
      } else if (this.isExploration(api)) {
        // Wenn EXPLO dann anders
        let allItems = this.afsData.Categories.reduce((acc, obj) => [...acc, ...obj.AFSItems], []);
        let item = allItems.find(x => x.ExternalSurveyId === api.ExternalSurveyId);
        if (item) {
          return item.Weight;
        }
      } else if (this.isNonExploration(api)) {
        // Wenn Non-Explo dann anders
        let allItems = this.nonAfsData.Categories.reduce((acc, obj) => [...acc, ...obj.AFSItems], []);
        let item = allItems.find(x => x.ExternalSurveyId === api.ExternalSurveyId);
         if (item) {
          return item.Weight;
        }
      }
      return undefined;
    },

    handleBadges(badges) {
      this.showBadges = badges;
    },

    getScenarioData(api, scenario) {
      return scenario;
    },

    getApiData(api) {
      if (this.isApi(api))
        return this.explorationData.find(x => x.ApiID == api.apiId);

      if (this.isExploration(api)) {
        for (const cat of this.afsData.Categories) {
          for (const item of cat.AFSItems) {
            if (item.ExternalSurveyId == api.ExternalSurveyId) {
              return item;
            }
          }
        }
      }

      if (this.isNonExploration(api)) {
        for (const cat of this.nonAfsData.Categories) {
          for (const item of cat.AFSItems) {
            if (item.ExternalSurveyId == api.ExternalSurveyId) {
              return item;
            }
          }
        }
      }
      return undefined;
    }
  },

  computed: {
    isEnabled() {
      for (let i = 0; i < this.category.apis.length; i++) {
        const api = this.category.apis[i];
        let item = this.getApiData(api);
        if(item && item.OverallScores) {
          return true;
        }
        if(item && item.WaveResults) {
          return true;
        }
      }
      return false;
    }
  }
}
</script>

<style lang="scss">
  .local-row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 1fr 1fr 1fr;
  }

  .local-row-exploration {
    display: grid;
    grid-template-columns: 2fr 3fr 1fr 1fr;
  }

  // Weight Badge
  .highlighting {
    position: relative;
    box-shadow: inset 0 0px 6px var(--weight-indicator-border-color)!important; 
  }

  .weight-badge {
    background-color: var(--weight-indicator-text-background)!important;
    color:var(--weight-indicator-text);
    position: absolute;
    font-size: 1rem !important;
  }

  .weight-badge-nonexploration {
    right: -1rem;
    top: -0.75rem!important;
  }

  .weight-badge-exploration {
    right: -1rem;
    top: -0.5rem!important;
  }
</style>